import axios from 'axios';
import swal from "sweetalert";
import { loginConfirmedAction, logout } from '../store/reducers/AuthReducer';




export function login(email, password) {
    const postData = {
        email,
        password,
    };
    console.log(process.env.REACT_APP_API_URL)
    return axios.post(
        `${process.env.REACT_APP_API_URL}/api/login`,
        postData,
    );
}

export function formatError(errorResponse) {
    switch (errorResponse.error.message) {
        case 'EMAIL_EXISTS':
            //return 'Email already exists';
            swal("Oops", "Email already exists", "error");
            break;
        case 'EMAIL_NOT_FOUND':
            //return 'Email not found';
            swal("Oops", "Email not found", "error", { button: "Try Again!", });
            break;
        case 'INVALID_PASSWORD':
            //return 'Invalid Password';
            swal("Oops", "Invalid Password", "error", { button: "Try Again!", });
            break;
        case 'USER_DISABLED':
            return 'User Disabled';

        default:
            return '';
    }
}

export function saveTokenInLocalStorage(tokenDetails) {

    localStorage.setItem('userDetails', JSON.stringify(tokenDetails));
}

export function runLogoutTimer(dispatch, timer, history) {
    setTimeout(() => {
        dispatch(logout(history));
    }, timer);
}

export function checkAutoLogin(dispatch, history) {
    const tokenDetailsString = localStorage.getItem('userDetails');
    let tokenDetails = '';
    if (!tokenDetailsString) {
        // history?.push('/');
        dispatch(logout());

        return;
    }

    tokenDetails = JSON.parse(tokenDetailsString);

    dispatch(loginConfirmedAction(tokenDetails));


}
